import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=db976f52&scoped=true&"
import script from "./FooterComponent.vue?vue&type=script&lang=js&"
export * from "./FooterComponent.vue?vue&type=script&lang=js&"
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=db976f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db976f52",
  null
  
)

export default component.exports